import PageHeaderActions from "Components/Common/PageHeaderActions";
import PaymentList from "Components/Payments/PaymentList";
import { useNavigate } from "react-router-dom";
import { Container } from "reactstrap";

const Payments = () => {
  document.title = "Payments | EaziQuote";
  const navigate = useNavigate();

  return (
    <div className="page-content">
      <Container fluid>
        <div className="gap-3 d-flex flex-column">
          <PageHeaderActions
            title="Payments"
            subtitle="Manage all your payments in one place"
            actions={[
              {
                label: "Create Payment Record",
                leftIcon: <i className="ri-add-fill me-1 align-bottom"></i>,
                onClick: () => navigate("/record-payment"),
              },
            ]}
          />
          <PaymentList />
        </div>
      </Container>
    </div>
  );
};

export default Payments;
